import React from 'react';
import DeviationDuperbrowseContext from '../../../../Duperbrowse/DeviationDuperbrowseContext';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import TierSidebarCard from '../../../../DeviationViews/TierSidebarCard';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import { getTierListCardBI } from '../../../helpers';
import SubscriptionLockFTUE from '../../../../Tier/ftue/SubscriptionLockFTUE';
import { useSubscriptionLockSidebarFTUE } from '../../../../Tier/ftue/useSubscriptionLockFTUE';
import s from './TierList.scss';
const TierList = ({ block , deviation: parentDeviation  })=>{
    var _block_deviations;
    const { isShowingSubscriptionsFTUE , dropFlag  } = useSubscriptionLockSidebarFTUE(block.contentType, parentDeviation);
    var _block_deviations1;
    return /*#__PURE__*/ React.createElement(SidebarBlockWrapper, {
        deviation: parentDeviation,
        block: block,
        className: s[block.contentType],
        headerClassName: s['header'],
        titleClassName: s['title'],
        seeAllClassName: s['link']
    }, /*#__PURE__*/ React.createElement(DeviationDuperbrowseContext, {
        streamId: `sidebar-tiers-${block.contentType}`,
        deviations: (_block_deviations1 = block.deviations) !== null && _block_deviations1 !== void 0 ? _block_deviations1 : [],
        parent: {
            typeId: getDeviationResourceType(parentDeviation),
            itemId: parentDeviation.deviationId
        }
    }, (_block_deviations = block.deviations) === null || _block_deviations === void 0 ? void 0 : _block_deviations.map((tier, i)=>isShowingSubscriptionsFTUE && i === 0 ? /*#__PURE__*/ React.createElement(SubscriptionLockFTUE, {
            dropFlag: dropFlag,
            className: s['ftue'],
            key: tier.deviationId,
            deviation: tier
        }) : /*#__PURE__*/ React.createElement(TierSidebarCard, {
            key: tier.deviationId,
            biData: getTierListCardBI(block.contentType, tier),
            className: s['tier'],
            deviation: tier
        }))));
};
TierList.displayName = 'TierList';
export default TierList;
